/**
 * @desc 新增
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.TripartiteSystemAuthRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/tripartiteSystemAuth/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
